import { useForm, UseFormReturn } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { AxiosError } from 'axios';
import { MutationStatus, UseMutateFunction } from 'react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  RetrievePaymentDetailsFormData,
  schemaRetrievePaymentDetails,
} from '../schema/schemaRetrievePaymentDetails';
import {
  SchoolCandidatePaymentDetailsRequest,
  SchoolCandidatePaymentDetailsResponse,
  usePostRetrieveSchoolCandidatePaymentDetails,
} from '../../../../../api-refactored/school-candidate-payment/usePostRetrieveSchoolCandidatePaymentDetails';
import { GenericErrorResponse } from '../../../../../api';
import { useGetSchoolsForSchoolCandidatePayment } from '../../../../../api-refactored/school-candidate-payment/useGetSchoolsForSchoolCandidatePayment';
import { LookupListApiItem } from '../../../../../api/user/model';

export interface UsePostRetrievePaymentDetailsInterface {
  form: UseFormReturn<RetrievePaymentDetailsFormData>;
  schools?: LookupListApiItem[];
  retrievePaymentDetailsResponse?: SchoolCandidatePaymentDetailsResponse;
  postRetrievePaymentDetailsMutation: UseMutateFunction<
    SchoolCandidatePaymentDetailsResponse,
    AxiosError<GenericErrorResponse>,
    SchoolCandidatePaymentDetailsRequest
  >;
  postRetrievePaymentDetailsApiStatus: MutationStatus;
  errorMessage: string;
}

export const usePostRetrievePaymentDetailsForm = (): UsePostRetrievePaymentDetailsInterface => {
  const [errorMessage, setErrorMessage] = useState('');
  const { t } = useTranslation();
  const form = useForm<RetrievePaymentDetailsFormData>({
    mode: 'onSubmit',
    resolver: joiResolver(schemaRetrievePaymentDetails),
  });

  const {
    data: retrievePaymentDetailsResponse,
    mutate: postRetrievePaymentDetailsMutation,
    status: postRetrievePaymentDetailsApiStatus,
  } = usePostRetrieveSchoolCandidatePaymentDetails({
    onSuccess: () => {
      setErrorMessage('');
    },
    onError: (err) => {
      if (err.response?.status === 403) {
        setErrorMessage(t('profile->>LoginForm.PleaseRefreshThePage'));
      } else {
        setErrorMessage(err.response?.data.message ?? '');
      }
    },
  });

  const { data: schools } = useGetSchoolsForSchoolCandidatePayment({});

  return {
    form,
    schools,
    retrievePaymentDetailsResponse,
    postRetrievePaymentDetailsMutation,
    postRetrievePaymentDetailsApiStatus,
    errorMessage,
  };
};
